var toLength = require('../internals/to-length');

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/length-of-array-like.js
// module id = 237
// module chunks = 0